<template>
    <b-card>
        <b-overlay :show="show" rounded="sm">
            <!-- form -->
            <b-form class="mt-2" @submit.stop.prevent="update">
                <b-row>
                    <b-col md="12" v-if="user.plan">
                        <app-timeline>
                            <app-timeline-item icon="DollarSignIcon">
                                <div
                                    class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
                                >
                                    <h3 class="text-warning">
                                        Plan Contratado: {{ user.plan.plan }}
                                    </h3>
                                </div>
                                <div
                                    class="d-flex flex-sm-row flex-column justify-content-between align-items-start"
                                >
                                    <div class="mb-1 mb-sm-0">
                                        <p class="text-white">
                                            Inicio: {{ user.fecha_inicio }}
                                        </p>
                                    </div>
                                    <div class="mb-1 mb-sm-0">
                                        <p class="text-white">
                                            Vencimiento: {{ user.fecha_fin }}
                                        </p>
                                    </div>
                                    <div class="mb-1 mb-sm-0"></div>
                                </div>
                            </app-timeline-item>
                        </app-timeline>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-form-group label="E-mail" label-for="account-e-mail">
                            <b-form-input
                                v-model="user.email"
                                name="account-e-mail"
                                placeholder="Email"
                                disabled
                                class="text-white"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group label="Tipo de identificación">
                            <b-form-radio-group
                                id="radio-group-1"
                                v-model="user.tipo_iden"
                                :options="options"
                                name="radio-options"
                            ></b-form-radio-group>
                        </b-form-group>
                    </b-col>

                    <b-col sm="8">
                        <b-form-group
                            label="Identificación"
                            label-for="account-ruc"
                        >
                            <b-form-input
                                v-model="user.identificacion"
                                placeholder="Identificación"
                                name="account-ruc"
                                v-on:blur="verifyRuc"
                                :state="isValidCliente"
                                required
                                class="text-white"
                            />
                            <b-form-valid-feedback
                                v-if="isValidCliente == true"
                            >
                                Información ingresada correctamente.
                            </b-form-valid-feedback>
                            <b-form-invalid-feedback
                                v-if="isValidCliente == false"
                            >
                                La información indicada ya existe.
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12">
                        <b-form-group
                            label="Apellidos"
                            label-for="account-surname"
                        >
                            <b-form-input
                                v-model="user.surname"
                                name="account-surname"
                                placeholder="Apellidos"
                                class="text-white"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col sm="12">
                        <b-form-group label="Nombres" label-for="account-name">
                            <b-form-input
                                v-model="user.name"
                                name="account-e-mail"
                                placeholder="Nombres"
                                class="text-white"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col sm="12">
                        <b-form-group
                            label="Teléfono"
                            label-for="account-phone"
                        >
                            <b-form-input
                                v-model="user.telefono"
                                name="account-phone"
                                placeholder="Telefono"
                                class="text-white"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col sm="12">
                        <b-form-group
                            label="Dirección"
                            label-for="account-address"
                        >
                            <b-form-input
                                v-model="user.direccion"
                                name="account-address"
                                placeholder="Direccion"
                                class="text-white"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col sm="12" hidden>
                        <b-form-group
                            label="Fecha Nacimiento"
                            label-for="account-date"
                        >
                            <flat-pickr
                                v-model="user.fechanacimiento"
                                name="account-date"
                                placeholder="Año/Mes/Dìa"
                                class="form-control text-white"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col cols="12" class="mb-2" align="center">
                        <b-button
                            variant="warning"
                            type="submit"
                            class="mt-2 mr-1 float-right btn_style"
                        >
                            Guardar
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-overlay>
    </b-card>
</template>

<script>
import {
    BButton,
    BFormRadioGroup,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BFormInvalidFeedback,
    BFormValidFeedback,
    BOverlay
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";

export default {
    components: {
        BButton,
        BForm,
        BFormGroup,
        BFormRadioGroup,
        BFormInput,
        BRow,
        BCol,
        BAlert,
        BCard,
        BCardText,
        BFormInvalidFeedback,
        BFormValidFeedback,
        BOverlay,
        flatPickr,
        AppTimeline,
        AppTimelineItem
    },
    directives: {
        Ripple
    },
    setup() {},
    created() {
        this.search();
    },
    data() {
        return {
            userData: JSON.parse(localStorage.getItem("userData")),
            show: false,
            isValidCliente: null,
            user: {
                idusuario: null,
                tipo_iden: null,
                identificacion: null,
                name: "",
                surname: "",
                email: "",
                telefono: "",
                direccion: "",
                fechanacimiento: ""
            },
            tipo_identificacion: "C",
            options: [
                { text: "Cédula", value: "C" },
                { text: "Pasaporte", value: "P" },
                { text: "RUC", value: "R" }
            ]
        };
    },
    methods: {
        search() {
            this.$http
                .get("api/usuario/" + this.userData.id)
                .then(response => {
                    this.user = response.data.data;
                })
                .catch(error => {
                    this.showToast(error, "danger", "IconCancel");
                });
        },
        verifyRuc() {
            this.$http
                .get("/api/usuario", {
                    params: {
                        identificacion: this.userData.id
                    }
                })
                .then(rest => {
                    const user = rest.data.data;
                    if (user.length > 0) {
                        this.isValidCliente = false;
                    } else {
                        this.isValidCliente = true;
                    }
                });
        },
        update() {
            this.show = true;
            this.$http
                .put("api/usuario/" + this.userData.id, this.user)
                .then(response => {
                    this.show = false;
                    this.items = response.data.data;
                })
                .catch(error => {
                    this.show = false;
                    this.showToast(error, "danger", "IconCancel");
                });
        },
        showToast(message, variant, icon) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: message,
                    variant: variant,
                    icon: icon
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-flatpicker.scss";
.repeater-form {
    overflow: hidden;
    transition: 0.35s height;
}

.btn_style {
    color: #004e7c !important;
}
</style>
